// LiveSessionContext — mantiene VIVA la sesión de video Agora aunque el
// usuario navegue a otro módulo (Bug 3). AgoraRoom se monta UNA sola
// vez en <PersistentLiveRoom/> (dentro del Layout, fuera del <Outlet/>), así no
// se recrea al cambiar de ruta: solo cambia su posición/tamaño con CSS.
import { createContext, useCallback, useContext, useState } from "react";

const LiveSessionContext = createContext(null);

export function LiveSessionProvider({ children }) {
  // session = { classId, data, roomPath } | null
  const [session, setSession] = useState(null);
  // Elemento del DOM donde la sala se "acopla" mientras estás en su página.
  const [dockEl, setDockEl] = useState(null);

  const openSession = useCallback((classId, data, roomPath) => {
    setSession((prev) => {
      // Idempotente: si ya hay sesión de ESTA clase, conservamos el video vivo
      // (no reemplazamos data para no forzar recarga de Agora al reingresar).
      if (prev && prev.classId === classId) {
        return { ...prev, roomPath: roomPath || prev.roomPath };
      }
      return { classId, data, roomPath };
    });
  }, []);

  const closeSession = useCallback(() => {
    setSession(null);
    setDockEl(null);
  }, []);

  const registerDock = useCallback((el) => setDockEl(el), []);

  return (
    <LiveSessionContext.Provider
      value={{ session, openSession, closeSession, dockEl, registerDock }}
    >
      {children}
    </LiveSessionContext.Provider>
  );
}

export function useLiveSession() {
  const ctx = useContext(LiveSessionContext);
  if (!ctx) throw new Error("useLiveSession debe usarse dentro de LiveSessionProvider");
  return ctx;
}
